import React, { useEffect } from "react";
import addUploadIcon from "../../assets/Icons/addUploadIcon.svg";
import addBulkUploadIcon from "../../assets/Icons/addBulkUploadIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";

import AdminAppBar from "../adminComponents/AdminAppBar";
import { toast, ToastContainer } from "react-toastify";
import BackArrows from "../Form/BackArrow/BackArrows";
import { LuInfo } from "react-icons/lu";
import CustomHeading from "../common/CustomHeading";

const LeadUploadPanel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = JSON.parse(localStorage?.getItem("userData"))?.user?.role;

  const handleManualClick = () => {
    if (userRole === "Admin") {
      navigate("/admin/lead-upload/manual");
    } else if (userRole === "CMO") {
      navigate("/cmo/lead-upload/manual");
    } else if (userRole === "BOD") {
      navigate("/bod/lead-upload/manual");
    } else if (userRole === "Lead Uploader") {
      navigate("/lead-uploader/lead-upload/manual");
    }
  };

  const handleBulkUploadClick = () => {
    if (userRole === "Admin") {
      navigate("/admin/lead-upload/bulk");
    } else if (userRole === "CMO") {
      navigate("/cmo/lead-upload/bulk");
    } else if (userRole === "BOD") {
      navigate("/bod/lead-upload/bulk");
    } else if (userRole === "Lead Uploader") {
      navigate("/lead-uploader/lead-upload/bulk");
    }
  };

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message, {
        position: "top-center",
        theme: "light",
        className: "absolute top-20",
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);


  return (
    <div className="fixed inset-0 flex flex-col bg-appGrayBackground">
      <AdminAppBar />
      <ToastContainer />

      <div className="flex-1 flex flex-col pt-20">
        <div className="container mx-auto flex-1 flex flex-col p-4">
          <div className="flex items-center gap-4 mb-4">
            <CustomHeading title={"Lead Upload Panel"} isIcon={
            userRole === "Lead Uploader" ? false : true
            } />
          
          </div>

          <div className="">
            <div className=" grid grid-cols-2 mx-40   xl:h-[380px] xl:mt-10 2xl:h-[400px] lg:mt-3 items-center  shadow-md rounded-lg  h-[500px] bg-white  4xl:h-[580px]  ">
              <div
                className="border-b md:border-b-0 md:border-r border-gray-300 flex items-center justify-center p-8 cursor-pointer"
                onClick={handleManualClick}
              >
                <div className="flex flex-col items-center text-center">
                  <img
                    className="w-24"
                    src={addUploadIcon}
                    alt=""
                  />
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    Manual Add
                  </h2>
                  <p className="text-gray-500 text-center">
                    Add leads one by one with detailed information
                  </p>
                </div>
              </div>

              <div
                className="flex items-center justify-center p-8 cursor-pointer"
                onClick={handleBulkUploadClick}
              >
                <div className="flex flex-col items-center text-center gap-2">
                  <img
                    className="w-24"
                    src={addBulkUploadIcon}
                    alt=""
                  />
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    Bulk Upload
                  </h2>
                  <p className="text-gray-500 text-center">
                    Upload multiple leads via Excel or Google Sheets
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="py-4 text-center">
            <p className="text-base md:text-lg">
              Note: Lead Uploaded here will be reflected in <br />
              admin panel as fresh lead
            </p>
          </div> */}
          {/* Note section */}
          <div className="mt-8 bg-green-50 border border-green-100 rounded-lg p-4 max-w-2xl mx-auto w-full">
            <div className="flex items-start gap-3">
              <LuInfo className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
              <p className="text-customGreen text-center">
                Leads uploaded here will be reflected in the admin panel as
                fresh leads, <br />
                ready for processing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadUploadPanel;
